import { Address } from "viem";

export const ccmSigners: Record<Address, string> = {
  "0xfd660518dc1b52d9f67facd42bbba962b06b8e54": "Igancio",
  "0x8cc8c75013d561ad81d7d08591836fc78585ae34": "Dima Lekhovitsky",
  "0xb9b7db94d57fe25907620eaae42b9780176cceea": "van0k",
  "0x66a3c94814dc3a37c9d61f1a977ea3730c621426": "Alex Mellow",
  "0x869ad60cdef31ae01959288ff77d51bcb9f09e41": "zefram.eth",
  "0xa0bace512e2904ccfdd24ab56feea6621ce14613": "Lewi",
  "0x0cec743b8ce4ef8802cac0e5df18a180ed8402a7": "Klim",
  "0x198c4d019bfe68415351e2c0f9b05585cfaaa5b": "Alex Smirnov",
  "0x225c529a6a84ae9e45f97b6692e387791c3ee8e8": "Simone",
  "0xb195a8cf4898e6ddc92e435cb118e9842456a45a": "MacLane Wilkison",
  "0xf33ea4ee285b5dac9a6163d8939699d59a7199ba": "Mikael Lazarev",
  "0xb647055a9915bf9c8021a684e175a353525b9890": "Matthew from TokenLogic",
};
